module.exports = __webpack_public_path__ + "img/MilitaryTabUnselected_ua.eee35af9.webp";